import { Expose } from "class-transformer";
import { PurchaseOrderStatusEnum } from "@altertec_gparn/lib";

export class ChangePurchaseOrderStatusDto {
  @Expose()
  id: string;

  @Expose()
  status: PurchaseOrderStatusEnum;
}
